import React from "react";
import {
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface EntityDetailLayoutProps {
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  isLoading?: boolean;
  onClose: () => void;
}

const EntityDetailLayout: React.FC<EntityDetailLayoutProps> = ({
  title,
  children,
  footer,
  isLoading,
  onClose,
}) => {
  return (
    <div className="flex flex-col h-full max-h-[85vh]">
      <DialogHeader className="sticky top-0 z-10 "></DialogHeader>

      <div className="flex-1 overflow-y-auto px-6 py-4">
        <div className="flex items-end justify-end mb-6">
          <DialogTitle className="text-xl font-semibold text-center w-full">{title}</DialogTitle>
        </div>
        {children}
      </div>

      {footer && (
        <DialogFooter className="sticky bottom-0 z-10  px-6 py-4 ">
          {footer}
        </DialogFooter>
      )}
    </div>
  );
};

export default EntityDetailLayout;
